export const KILLER_WS_URL =
  'wss://7ocsydxrfe.execute-api.eu-west-2.amazonaws.com/prod';
